import { render, staticRenderFns } from "./restriktionen-kalendertag-modal.vue?vue&type=template&id=994a57c4&scoped=true"
import script from "./restriktionen-kalendertag-modal.vue?vue&type=script&lang=js"
export * from "./restriktionen-kalendertag-modal.vue?vue&type=script&lang=js"
import style0 from "./restriktionen-kalendertag-modal.vue?vue&type=style&index=0&id=994a57c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994a57c4",
  null
  
)

export default component.exports